import { render, staticRenderFns } from "./AddDiscountSlab.vue?vue&type=template&id=7cbe0844&scoped=true&"
import script from "./AddDiscountSlab.vue?vue&type=script&lang=js&"
export * from "./AddDiscountSlab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbe0844",
  null
  
)

export default component.exports